import { FunctionComponent } from 'react';

import { Button, Header } from '@kanda-libs/ks-design-library';

interface OpenBankingSatNoteModalHeaderProps {
  onClick: () => void;
}

const OpenBankingSatNoteModalHeader: FunctionComponent<
  OpenBankingSatNoteModalHeaderProps
> = ({ onClick }) => (
  <Header.Base
    className="text-14-22-em md:text-20-24-em text-neutral-900"
    options={[
      <Button.Icon
        key="close"
        id="ob-sat-note-modal-close"
        onClick={onClick}
        icon="close"
      />,
    ]}
  >
    <p>Sign Sat Note</p>
  </Header.Base>
);

export default OpenBankingSatNoteModalHeader;
